// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2YvP3","checkboxCol":"Table_checkboxCol__3tXAa","emailCol":"Table_emailCol__2ftKk","actionCol":"Table_actionCol__3WNPv"};